import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import downloadWhite from "images/downloadWhite.svg";
import {
  CommonStyle,
  CommonHeaderStyle,
  displayNullFormatter,
} from "../Utility/utilis";
import { useDispatch, useSelector } from "react-redux";
import NoData from "../Utility/NoData";
import ReactPaginate from "react-paginate";
import { Button } from "@material-ui/core";
import {
  setSelected,
  setSelectedRow,
  downloadReport,
  setNoticeTableData,
  setSearch,
} from "./action";

export default function Table(props) {
  const { noticeTableData, totalPages, selected, selectedRow } = useSelector(
    (state) => state.noticeReducer
  );
  const dispatch = useDispatch();
  const [selectedDocType, setSelectedDocType] = useState("");

  const downloadFile = (row, type) => {
    dispatch(downloadReport(row?.refId, type));
  };
  const selectRow = {
    mode: "checkbox",
    selected: selected,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    nonSelectable:
      noticeTableData
        ?.filter((row) => (row?.noticeData?.suppdocs?.length || 0) === 0 && (row?.noticeData?.maindocs?.length || 0) === 0)
        ?.map((row) => row.id) || [],
    headerColumnStyle: {
      width: "37px",
      verticalAlign: "middle",
    },
    selectColumnStyle: {
      width: "37px",
      textAlign: "center",
      verticalAlign: "middle",
    },
  };
  const handleStatusChange = (newStatus, rowIndex) => {
    const updatedData = [...noticeTableData];
    updatedData[rowIndex].MarkStatus = newStatus;
    dispatch(setNoticeTableData(updatedData));
  };

  const handleDocumentTypeChange = (type, row) => {
    if (type === "case") {
      alert("Download Case Wise");
    } else if (type === "note") {
      alert("Download Note Wise");
    }
  };

  const downloadDropdown = (row) => <Button>Download</Button>;

  const MarkStatusDropdown = (cell, rowIndex) => {
    return (
      <select
        value={cell || ""}
        onChange={(e) => handleStatusChange(e.target.value, rowIndex)}
      >
        <option value="" disabled hidden>
          Select
        </option>
        <option value="Closed">Closed</option>
        <option value="Reply Filled">Reply Filled</option>
        <option value="Inprogress">In Progress</option>
      </select>
    );
  };

  const FetchStatusColor = (row) => {
    return (
      <div
        style={{
          cursor: row?.status?.toUpperCase() == "FAILED" ? "pointer" : "auto",
          width: "100%",
          textAlign: "center",
          color:
            row?.status?.toUpperCase() == "FAILED"
              ? "red"
              : row?.status?.toUpperCase() == "COMPLETED"
              ? "green"
              : "black",
        }}
      >
        {row?.status?.toUpperCase() == "COMPLETED" ||
        row?.status?.toUpperCase() == "FAILED"
          ? row.status
          : "In-progress"}
      </div>
    );
  };

  const columns = [
    {
      dataField: "gstin",
      text: "GSTIN of Taxpayer",
      style: () => ({ ...CommonStyle(), width: "12%" }),
      headerStyle: CommonHeaderStyle(),
      formatter: (cell, row) => displayNullFormatter(row, "gstin"),
    },
    // {
    //   dataField: "caseSk",
    //   text: "Case ID",
    //   style: () => ({ ...CommonStyle(), width: "7%" }),
    //   headerStyle: CommonHeaderStyle,
    // },
    {
      dataField: "refId",
      text: "Reference ID",
      style: () => ({ ...CommonStyle(), width: "11%" }),
      headerStyle: CommonHeaderStyle,
      formatter: (cell, row) => displayNullFormatter(row, "refId"),
    },
    {
      dataField: "issueDate",
      text: "Date of issue",
      style: () => ({ ...CommonStyle(), width: "11%" }),
      headerStyle: CommonHeaderStyle,
      formatter: (cell, row) => {
        return row?.noticeData?.dateOfIssue ?? "--";
      },
    },
    {
      dataField: "DueDateofReply",
      text: "Due Date of Reply",
      style: () => ({ ...CommonStyle(), width: "11%" }),
      headerStyle: CommonHeaderStyle,
      formatter: (cell, row) => {
        return row?.noticeData?.dueDateOfReply ?? "--";
      },
    },

    {
      dataField: "FromPeriod",
      text: "From Period",
      style: () => ({ ...CommonStyle(), width: "11%" }),
      headerStyle: CommonHeaderStyle,
      formatter: (cell, row) => {
        return row?.noticeData?.taxPeriod &&
          row?.noticeData?.taxPeriod?.fromMonth &&
          row?.noticeData?.taxPeriod?.fromYear
          ? `${row?.noticeData?.taxPeriod?.fromMonth} - ${row?.noticeData?.taxPeriod?.fromYear}`
          : "--";
      },
    },
    {
      dataField: "ToPeriod",
      text: "To Period",
      style: () => ({ ...CommonStyle(), width: "11%" }),
      headerStyle: CommonHeaderStyle,
      formatter: (cell, row) => {
        return row?.noticeData?.taxPeriod &&
          row?.noticeData?.taxPeriod?.toMonth &&
          row?.noticeData?.taxPeriod?.toYear
          ? `${row?.noticeData?.taxPeriod?.toMonth} - ${row?.noticeData?.taxPeriod?.toYear}`
          : "--";
      },
    },
    {
      dataField: "noticeType",
      text: "Notice Type",
      style: () => ({ ...CommonStyle(), width: "10%" }),
      headerStyle: CommonHeaderStyle,
      formatter: (cell, row) => {
        return row?.noticeData?.noticeType ?? "--";
      },
    },

    {
      dataField: "documentCountMain",
      text: "Main Document",
      formatter: (cell, row) => {
        return (
          <div
            style={{
              width: "100%",
              cursor:
                row?.noticeData?.maindocs?.length !== 0 ? "pointer" : "auto",
              color: row?.noticeData?.maindocs?.length !== 0 ? "blue" : "black",
            }}
            onClick={
              row?.noticeData?.maindocs?.length !== 0
                ? () => downloadFile(row, "main")
                : null
            }
          >
            {row?.noticeData?.maindocs?.length ?? "--"}
          </div>
        );
      },
      style: () => ({ ...CommonStyle(), width: "11%" }),
      headerStyle: CommonHeaderStyle,
      // formatter: (cell, row) => {
      //  return row?.noticeData?.maindocs?.length ?? '--'
      // }
    },
    {
      dataField: "documentCountSupporting",
      text: "Supporting Document",
      formatter: (cell, row) => {
        return (
          <div
            style={{
              width: "100%",
              cursor:
                row?.noticeData?.suppdocs?.length !== 0 ? "pointer" : "auto",
              color: row?.noticeData?.suppdocs?.length !== 0 ? "blue" : "black",
            }}
            onClick={
              row?.noticeData?.suppdocs?.length !== 0
                ? () => downloadFile(row, "supporting")
                : null
            }
          >
            {row?.noticeData?.suppdocs?.length ?? "--"}
          </div>
        );
      },
      style: () => ({ ...CommonStyle(), width: "11%" }),
      headerStyle: CommonHeaderStyle,
      // formatter: (cell, row) => {
      //  return row?.noticeData?.suppdocs?.length ?? '--'
      // }
    },
    // {
    //   dataField: "markStatus",
    //   text: "Mark Status",
    //   formatter: (cell, row, rowIndex) => MarkStatusDropdown(cell, rowIndex),
    //   style: () => ({ ...CommonStyle(), width: "8%" }),
    //   headerStyle: CommonHeaderStyle,
    // },

    // {
    //   dataField: "FetchStatus",
    //   text: "Fetch Status",
    //   style: (cell, row, rowIndex, colIndex) => ({
    //     ...CommonStyle(),
    //     width: "9%",
    //   }),
    //   headerStyle: {
    //     ...CommonHeaderStyle(),
    //   },
    //   formatter: (cell, row) => FetchStatusColor(row),
    // },
  ];

  function handleOnSelect(row, isSelect) {
    if (isSelect) {
      dispatch(setSelected([...selected, row.id]));
      dispatch(setSelectedRow([...selectedRow, row]));
    } else {
      const updated = selected.filter((id) => id !== row.id);
      dispatch(setSelected(updated));

      const updatedRows = selectedRow.filter((r) => r.id !== row.id);
      dispatch(setSelectedRow(updatedRows));
    }
  }

  function handleOnSelectAll(isSelect, rows) {
    const ids = rows.map((r) => r.id);
    if (isSelect) {
      dispatch(setSelected(ids));
      dispatch(setSelectedRow(rows));
    } else {
      dispatch(setSelected([]));
      dispatch(setSelectedRow([]));
    }
  }

  useEffect(() => {
    return () => {
      dispatch(setSelected([]));
      dispatch(setSelectedRow([]));
      dispatch(setSearch(""));
    };
  }, []);
  const rowStyle2 = (row, rowIndex) => {
    const style = {};
    style.backgroundColor = "#fff";
    return style;
  };
  return (
    <>
      {noticeTableData?.length > 0 ? (
        <>
          <div
            style={{
              marginTop: "0.7em",
              width: "100%",
              // overflowX: "scroll"
            }}
          >
            <div
              style={{
                height: "25em",
                width: "100%",
                // overflowY: "scroll"
              }}
            >
              <div className="light-border-notice-table">
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  <div
                    className="notice-documents-div"
                    style={{
                      width: "80%",
                    }}
                  ></div>
                  <div
                    className="notice-documents-div"
                    style={{
                      width: "17%",
                    }}
                  >
                    Documents
                  </div>
                  <div
                    className="notice-documents-div"
                    style={{
                      width: "3%",
                    }}
                  ></div>
                </div>
                <BootstrapTable
                  keyField="id"
                  data={noticeTableData}
                  columns={columns}
                  rowStyle={rowStyle2}
                  selectRow={selectRow}
                />
              </div>
              
            </div>
            
          </div>
          <div style={{marginTop:'1em'}}>
          <br/>
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            forcePage={props.pageNumber - 1}
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={props.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
          />
          </div>
        </>
      ) : (
        <NoData />
      )}
    </>
  );
}
